






































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'SecondaryWalletsEditSettingsDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    valid = true;
    dialog = false;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            ProductDetailsModule.prepareSecondaryWalletTypeViewModel();
        }
    }

    get currentSecondaryWallet() {
        return ProductDetailsModule.currentSecondaryWalletTypeViewModel;
    }

    get availableCurrencies() {
        return AuthModule.me.institution.config.availableCurrencies;
    }

    async save() {
        if (!this.valid) {
            return;
        }
        else {
            this.dialog = false;

            // If the CryptocurrencyOverride is enabled then override the crypto currencies
            // with a real currency so that they still work when sent to the platform
            if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.CryptocurrencyOverride)) {
                // Replace BTC with XPT
                this.currentSecondaryWallet.generalSettings.allowedCurrencies = this.currentSecondaryWallet.generalSettings.allowedCurrencies.map((currency) => { return currency === "BTC" ? "XPT" : currency; });
                // Replace ETH with XPD
                this.currentSecondaryWallet.generalSettings.allowedCurrencies = this.currentSecondaryWallet.generalSettings.allowedCurrencies.map((currency) => { return currency === "ETH" ? "XPD" : currency; });
            }

            await ProductDetailsModule.editSecondaryWalletTypeGeneralSettings();
        }
    }

}
